import { faClock } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { appointableHelper } from "@gymflow/helpers";
import { AppointableDTO } from "@gymflow/types";
import { usePortalRoutes } from "apps/portal/src/hooks";
import { AuthenticationContext } from "apps/portal/src/providers/authentication/AuthenticationContext";
import { RouteFeature } from "apps/portal/src/routes";
import { Duration } from "luxon";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { SessionOverlayContext } from "../../../../providers/authentication/SessionOverlay/SessionOverlayContext";
import { OnboardingContext } from "../../../../providers/OnboardingProvider/OnboardingContext";
import { Button } from "../../../atoms";
import { HostedPagesCard } from "../../components/HostedPagesCard";

export type HostedPagesAppointableCardProps = {
  appointable: AppointableDTO;
  activeSubscription: boolean;
};

const HostedPagesAppointableCard = ({
  appointable,
  activeSubscription,
}: HostedPagesAppointableCardProps) => {
  const { createSiteOrEmbedLink } = usePortalRoutes();
  const { t } = useTranslation();
  const { setSessionOverlayState } = useContext(SessionOverlayContext);
  const { userId: id } = useContext(AuthenticationContext);
  const singleHost = appointableHelper.getSingleHost(appointable);
  const { currentScreen } = useContext(OnboardingContext);
  const nextStepLink = createSiteOrEmbedLink(
    (appointable.description ||
    appointable.termsAndConditions ||
    currentScreen === "banner"
      ? RouteFeature.AppointableId
      : !singleHost
        ? RouteFeature.AppointableIdSelect
        : RouteFeature.AppointableIdSelectTime
    )
      .replace(":appointableId", appointable.id.toString())
      .replace(":staffOrFacilityId", singleHost?.toString() ?? ""),
  );
  return (
    <HostedPagesCard.Container>
      <HostedPagesCard.Header>
        <div className="flex flex-row justify-between gap-4">
          <div className="flex w-full max-w-full flex-row items-center justify-between gap-1">
            <div className="dark:text-gray-0 text-lg font-bold text-gray-950">
              {appointable.name}
            </div>
            <div className="dark:text-gray-0 flex items-center gap-1 font-semibold text-gray-950">
              <FontAwesomeIcon
                className="size-4 text-gray-500"
                icon={faClock}
              />
              {Duration.fromObject({
                minutes: appointable.duration,
              })
                .rescale()
                .toHuman({
                  unitDisplay: "narrow",
                  listStyle: "short",
                })}
            </div>
          </div>
        </div>
      </HostedPagesCard.Header>
      <HostedPagesCard.Separator />
      <HostedPagesCard.Footer>
        <HostedPagesCard.AppointablePrice
          appointable={appointable}
          activeSubscription={activeSubscription}
        />
        {!id ? (
          <Button
            intent="secondary-outline"
            className="min-w-32"
            onClick={async () => {
              setSessionOverlayState({
                screen: "try-sign-in",
              });
            }}
          >
            {t("portal.common.viewMore")}
          </Button>
        ) : (
          <Button
            intent="secondary-outline"
            className="min-w-32"
            link={nextStepLink}
          >
            {t("portal.common.viewMore")}
          </Button>
        )}
      </HostedPagesCard.Footer>
    </HostedPagesCard.Container>
  );
};
export default HostedPagesAppointableCard;
